import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content-page-element-visibility-rule d-flex flex-column justify-content-between h-100" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "add", -1)
const _hoisted_4 = { class: "footer row align-items-center pt-3 border-top border-1 border-black border-opacity-25" }
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertInfo = _resolveComponent("AlertInfo")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_VisibilityRule = _resolveComponent("VisibilityRule")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_AutoSaveFeedback = _resolveComponent("AutoSaveFeedback")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AlertInfo, {
        description: _ctx.$t('descriptionVisibilityRule'),
        class: "mb-5"
      }, null, 8, ["description"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.visibilityRuleForElementUI.getError()
      }, null, 8, ["error"]),
      (!_ctx.hasVisibilityRule)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-icon btn-secondary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addVisibilityRule && _ctx.addVisibilityRule(...args)))
          }, [
            _hoisted_3,
            _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_dp_form, {
        as: "form",
        novalidate: "",
        class: "row align-items-top"
      }, {
        default: _withCtx(({ errors }) => [
          (_ctx.hasVisibilityRule)
            ? (_openBlock(), _createBlock(_component_VisibilityRule, {
                key: 0,
                payload: _ctx.visibilityRuleForElement.visibility_rule,
                errors: errors,
                onChanged: _ctx.onVisibilityRuleChanged,
                onDelete: _ctx.deleteVisibilityRule,
                onError: _ctx.setExceptions
              }, null, 8, ["payload", "errors", "onChanged", "onDelete", "onError"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args))),
          class: "btn btn-primary"
        }, _toDisplayString(_ctx.$t('save')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AutoSaveFeedback, { status: _ctx.autoSaveFeedbackStatus }, null, 8, ["status"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_base_offcanvas_button_close, { class: "btn btn-light" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}